<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Sisteminiai įrašai') }}</h1>

    <!-- search -->
    <admin-records-search @downloadReport="downloadReport" :loading="loading" @search="searchAdminRecords" />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import AdminRecordsSearch from './AdminRecordsSearch'
import userRole from '@/mixins/userRole'
import { mapGetters } from 'vuex'
import math from '@/mixins/math'

export default {
  name: 'AdminRecords',
  components: {
    AdminRecordsSearch,
  },
  mixins: [userRole, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    ...mapGetters(['listParams']),
    headers() {
      return [
        {
          text: this.$t('Naudotojas'),
          align: 'center',
          value: 'user',
        },
        {
          text: this.$t('Klaida / Gedimas'),
          align: 'start',
          value: 'error_text',
        },
        {
          text: this.$t('Nuoroda'),
          align: 'start',
          value: 'link',
        },
        {
          text: this.$t('Eilutė'),
          align: 'start',
          value: 'line',
        },
        {
          text: this.$t('Sukūrimo laikas'),
          align: 'start',
          value: 'created_at',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  created() {
    this.setlistParams()
  },
  methods: {
    setlistParams(){
      if (this.listParams && (this.pagination.pageSize != this.listParams.pageSize) && (this.listParams.pageSize != null)) {
        this.pagination.pageSize = this.listParams.pageSize
      } 
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`error-logs/list`, data)
        .then((res) => {
          this.listData = res.data.errorLogs
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchAdminRecords(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(true)
    },
     openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    downloadReport() {
      this.loading = true
      const data = {
        ...this.pagination,
        search: this.searchData,
        isReport: true,
      }
      this.$axios
        .post(`error-logs/list`, data)
        .then((res) => {
           this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
